import { AppState } from "../reducers";

export const getCurrentUserId = (state: AppState) => state.common?.currentUserId;
export const getCurrentUserGlobalRoleId = (state: AppState) => state.common?.currentUserRoleId;
export const getCompanyLogoHash = (state: AppState) => state.common.companyLogoHash;
export const getAllPageKeys = (state: AppState) => state.common.availablePages;
export const getShowPortfolios = (state: AppState) => state.common?.showPortfolios;
export const getInlineManualConfig = (state: AppState) => state.common?.inlineManualConfig;
export const getUserFlowConfig = (state: AppState) => state.common?.userFlowConfig;
export const getIntercomConfig = (state: AppState) => state.common?.intercomConfig;
export const getAmplitudeConfig = (state: AppState) => state.common?.amplitudeConfig;
export const getClarityConfig = (state: AppState) => state.common?.clarityConfig;
export const getIsGuest = (state: AppState) => !!state.common.isGuest;
/*
 * When support team log in as a user to the customer account.
 */
export const getIsSupportUser = (state: AppState) => state.common.isSupportUser === true;
export const getCurrentUserAvatarHash = (state: AppState) => state.common.currentUserAvatarHash;
export const getAvatarsVersion = (state: AppState) => state.common.avatarsVersion;
export const getIsRegularUser = (state: AppState) => !getIsGuest(state);
export const getAccountId = (state: AppState) => state.common.accountId;
